import type { MenuProps } from 'antd'
import { ReactComponent as Logo } from 'assets/svg/icon-logo.svg'
import cls from 'classnames'
import { useCssInJs } from 'hooks/useCssInJs'
import React, {
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react'

import type { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb'
import LazyComponent from 'components/LazyComponent'
import { Link, useLocation } from 'react-router-dom'
import { genLayoutStyle } from './styles'
// import { ReactComponent as Logo } from 'assets/svg/logo.svg'

type MenuItem = Required<MenuProps>['items'][number]

type AppConfig = {
  appCode: string
}
type Props = {
  config: AppConfig
} & PropsWithChildren

type TLayoutContext = {
  config: AppConfig
  collapsed?: boolean
  setCollapsed: (collapsed: boolean | ((collapsed: boolean) => boolean)) => void
  baseBreadcrumb?: BreadcrumbItemType[]
  setBaseBreadcrumb: React.Dispatch<React.SetStateAction<BreadcrumbItemType[]>>
  breadcrumb: BreadcrumbItemType[]
  setBreadcrumb: React.Dispatch<React.SetStateAction<BreadcrumbItemType[]>>
}

export const LayoutContext = React.createContext<TLayoutContext>(null!)

export function useLayout() {
  return useContext(LayoutContext)
}

export function LayoutProvider(props: Props) {
  const { children, config } = props
  const [collapsed, setCollapsed] = useState(
    localStorage['collapsed'] === 'true' || false
  )

  const [baseBreadcrumb, setBaseBreadcrumb] = useState<BreadcrumbItemType[]>([])
  const [breadcrumb, setBreadcrumb] = useState<BreadcrumbItemType[]>([])

  useEffect(() => {
    localStorage['collapsed'] = collapsed
  }, [collapsed])
  return (
    <LayoutContext.Provider
      value={{
        config,
        collapsed,
        setCollapsed,
        breadcrumb,
        setBreadcrumb,
        baseBreadcrumb,
        setBaseBreadcrumb,
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}

export function Layout(props: PropsWithChildren) {
  const { children } = props
  const prefix = 'layout'
  const { wrapSSR, hashId } = useCssInJs({
    prefix: 'layout',
    styleFun: genLayoutStyle,
  })

  const location = useLocation()
  const { pathname } = location

  // const finalBreadcrumb = useMemo(() => {
  //   return [...baseBreadcrumb, ...breadcrumb]
  // }, [baseBreadcrumb, breadcrumb])

  return wrapSSR(
    <div className={cls(prefix, hashId)}>
      <div className='layout'>
        <div className='header'>
          <Link className='menuleft' to='/'>
            <img src='./logo.png' alt='logo' />
            <span className='title'>Compare in a Flash!</span>
          </Link>
          <div className='menuright'>
            <Link
              to='/text'
              className={cls('menurightButton', {
                active: pathname === '/text',
              })}
            >
              <span>Text Compare</span>
            </Link>
            <Link to='/file'>
              <span
                className={cls('menurightButton', {
                  active: pathname === '/file',
                })}
              >
                File Compare
              </span>
            </Link>
            <Link to='/image'>
              <span
                className={cls('menurightButton', {
                  active: pathname === '/image',
                })}
              >
                Image Compare
              </span>
            </Link>
          </div>
        </div>
        <div className='content'>
          <LazyComponent>{children}</LazyComponent>
        </div>
        <div className={cls('footer', hashId)}>
          <div className={cls('footerLinks', hashId)}>
            <Link to='/about' className={cls('footerLinksItem', hashId)}>
              About
            </Link>
            <Link
              to='/privacy-policy'
              className={cls('footerLinksItem', hashId)}
            >
              Privacy Policy
            </Link>
          </div>
          <div className={cls('copyright', hashId)}>
            © 2025 Fast Diff. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  )
}
